import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'prettyPhone'
})
export class PrettyPhone implements PipeTransform {
  transform(value: string): string | null {
    let theTransformedValue: string | null = null;
    if (!value) {
      theTransformedValue = `(${value.slice(0, 3)}) ${value.slice(3, 6)}-${value.slice(6, 10)}`;
    }
    return theTransformedValue;
  }
}
